import {
  Box,
  Chip,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  alpha,
} from '@mui/material'
import { useMemo, useState } from 'react'

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'

const ProductFeaturesTable = ({ productFeatures, getBackColor, getTextColor }) => {
  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    if (!search) return productFeatures

    return productFeatures.filter((f) => f.feature.toLowerCase().includes(search.toLowerCase()))
  }, [productFeatures, search])

  const renderBool = (value) =>
    value ? (
      <CheckCircleRoundedIcon
        sx={{
          color: '#56d364',
          fontSize: 18,
        }}
      />
    ) : null

  return (
    <Box
      sx={{
        mb: 1,
        mt: 3,
        borderRadius: 3,
        border: '1px solid rgba(255,255,255,.08)',
        boxShadow: '0 12px 35px rgba(0,0,0,.35)',
        p: 2,

        display: 'flex',
        flexDirection: 'column',

        flex: 1,
        minHeight: 0,
      }}>
      <Box
        sx={{
          px: 2.5,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Typography
          variant='h6'
          sx={{
            fontWeight: 600,
            color: getTextColor(),
          }}>
          Licensed Features
        </Typography>

        <Chip
          label={`${filtered.length} Features`}
          size='small'
          sx={{
            background: 'linear-gradient(135deg,#1976d2 0%,#42a5f5 100%)',
            color: 'white',
            fontWeight: 600,
            borderRadius: 3,
          }}
        />
      </Box>

      <Box px={2.5} pb={2}>
        <TextField
          fullWidth
          size='small'
          placeholder='Search licensed features...'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchRoundedIcon fontSize='small' />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <TableContainer
        sx={{
          height: '100%',
          overflowY: 'auto',
          bgcolor: getBackColor(),
          px: 1,
          pb: 1,
        }}>
        <Table
          stickyHeader
          size='small'
          sx={{
            borderCollapse: 'separate',
            borderSpacing: '0 4px',
          }}>
          <TableHead>
            <TableRow>
              {['Feature', 'Vision', 'Vantage', 'API', 'WSX'].map((header) => (
                <TableCell
                  key={header}
                  align={header === 'Feature' ? 'left' : 'center'}
                  sx={{
                    bgcolor: '#1976d2',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: 13,
                    py: 1,
                    borderBottom: 0,
                  }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered.map((row) => (
              <TableRow
                key={row.feature}
                hover
                sx={{
                  '&:hover td': {
                    bgcolor: alpha('#1976d2', 0.08),
                  },
                  boxShadow: '0 2px 6px rgba(0,0,0,.35)',
                }}>
                <TableCell
                  sx={{
                    color: getTextColor(),
                    border: 0,
                    borderTopLeftRadius: 8,
                    borderBottomLeftRadius: 8,
                    bgcolor: alpha('#fff', 0.02),
                    fontWeight: 500,
                    py: 1,
                  }}>
                  {row.feature}
                </TableCell>

                {[row.Vision, row.Vantage, row['Nexus API'], row['Well Seeker']].map((value, i) => (
                  <TableCell
                    key={i}
                    align='center'
                    sx={{
                      border: 0,
                      bgcolor: alpha('#fff', 0.02),
                      ...(i === 3 && {
                        borderTopRightRadius: 8,
                        borderBottomRightRadius: 8,
                      }),
                    }}>
                    {renderBool(value)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default ProductFeaturesTable
